<template>
	<div>
		<date-picker
			v-bind="$attrs"
			v-on="listeners"
			v-if="!hideDateInput"
			:label="dateLabel || this.$t('date')"
			:dateString.sync="dateString"
			:min="minDate"
			:max="maxDate"
		/>
		<simple-timecomplete
			v-bind="$attrs"
			v-on="listeners"
			:timeString.sync="timeString"
			:minuteStep="minuteStep"
			:label="timeLabel || this.$t('time')"
			:minTime="minTime"
			:maxTime="maxTime"
		/>
	</div>
</template>
<script>
import i18n from './dictionary';
import dayjs from 'dayjs';
import customParseFormatPlugin from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormatPlugin);

import DatePicker from '@/components/base/datePicker/DatePicker.vue';
import SimpleTimecomplete from '@/components/base/simpleTimecomplete/SimpleTimecomplete.vue';

export default {
	components: { DatePicker, SimpleTimecomplete },
	i18n,
	name: 'DateTimePicker',
	props: {
		value: {
			type: Date,
			required: true,
		},
		dateLabel: {
			type: String,
			default: null,
		},
		timeLabel: {
			type: String,
			default: null,
		},
		minuteStep: {
			type: Number,
			default: 30,
		},
		minDateTime: {
			type: [Date, dayjs],
			required: false,
		},
		maxDateTime: {
			type: [Date, dayjs],
			required: false,
		},
		hideDateInput: { type: Boolean, default: false },
	},
	computed: {
		listeners() {
			// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
			const { input, ...listeners } = this.$listeners;
			return listeners;
		},
		dateString: {
			get() {
				return dayjs(this.value).format('YYYY-MM-DD');
			},
			set(value) {
				const dateTime = dayjs(value + ' ' + this.timeString, 'YYYY-MM-DD HH:mm', true);
				if (dateTime.isValid()) this.$emit('input', dateTime.toDate());
			},
		},
		timeString: {
			get() {
				return dayjs(this.value).format('HH:mm');
			},
			set(value) {
				const dateTime = dayjs(this.dateString + ' ' + value, 'YYYY-MM-DD HH:mm', true);
				if (dateTime.isValid()) this.$emit('input', dateTime.toDate());
			},
		},
		minDate() {
			if (!this.minDateTime) return undefined;

			let minDateTime = this.minDateTime;
			if (minDateTime instanceof Date) minDateTime = dayjs(this.minDateTime);
			return minDateTime.format('YYYY-MM-DD');
		},
		maxDate() {
			if (!this.maxDateTime) return undefined;

			let maxDateTime = this.maxDateTime;
			if (maxDateTime instanceof Date) {
				maxDateTime = dayjs(maxDateTime);
			}
			maxDateTime = maxDateTime.hour(0).minute(0).second(0).millisecond(0);
			maxDateTime = maxDateTime.subtract(this.minuteStep, 'minute');

			return maxDateTime.format('YYYY-MM-DD');
		},
		minTime() {
			if (!this.minDateTime) return undefined;

			let minDateTime = this.minDateTime;
			if (minDateTime instanceof Date) minDateTime = dayjs(this.minDateTime);
			const minDateString = minDateTime.format('YYYY-MM-DD');

			if (this.dateString === minDateString) return minDateTime;
			else return undefined;
		},
		maxTime() {
			if (!this.minDateTime) return undefined;

			let maxDateTime = this.maxDateTime;
			if (maxDateTime instanceof Date) maxDateTime = dayjs(this.maxDateTime);
			const maxDateString = dayjs(this.maxDateTime).format('YYYY-MM-DD');
			if (this.dateString === maxDateString) return maxDateTime;
			else return undefined;
		},
	},
};
</script>
